import { currency, percent } from 'Helpers/Formats';

export const formatContentByHint = (hint, value) => {
  switch (hint) {
    case 'usd':
      return currency(value, true);
    case 'percent':
      return percent(Math.floor(10000 * value) / 100);
    default:
      return value;
  }
};

// On mobile, the padding on the left is absolutely killing the ability to look at this table and see what is going on.
// Decreasing the left padding makes it easier to see things
export const tableCellStyle = (theme) => ({
  '&:first-child': {
    paddingLeft: '0 !important',
  },
  '&:not(:first-child)': {
    [theme.breakpoints.down('sm')]: {
      paddingLeft: `${theme.spacing(1)} !important`,
    },
  },
});
